const config = {
  apiUrl: 'https://api-demo.sunbit.com',
  apiUrlPci: 'https://api-demo.sunbit.com',
};

export default config;



// WEBPACK FOOTER //
// ./src/config/oregon-demo.js